import { useCallback, useState } from 'react';
import PParamList from './PParamList';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';

/**
 * @author taulmax
 * @date 2024.10.17
 * @description 프롬프트 생성 페이지 - 파라미터 wrapper
 */
const PParamWrapper = ({
  insertAtCursor,
}: {
  insertAtCursor: (text: string) => void;
}) => {
  const [searchText, setSearchText] = useState<string>('');
  const onChangeSearchText = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setSearchText(e.target.value);
    },
    []
  );

  return (
    <div className="h-full flex flex-col">
      {/* 파라미터 검색 */}
      <div className="mb-4 px-4">
        <div className="relative">
          <input
            type="text"
            value={searchText}
            onChange={onChangeSearchText}
            placeholder="파라미터 검색..."
            className="w-full pl-10 pr-3 py-2 text-sm bg-white border border-gray-300 rounded-md focus:border-blue-500 focus:ring-1 focus:ring-blue-200 transition-all duration-200"
          />
          <FontAwesomeIcon 
            icon={faSearch} 
            className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 text-sm"
          />
        </div>
      </div>

      {/* 파라미터 리스트 */}
      <PParamList searchText={searchText} insertAtCursor={insertAtCursor} />
    </div>
  );
};

export default PParamWrapper;